export const deDuplicate = (array, key) => {
  return [
    ...new Map(
      array.map(item => [key(item), item])
    ).values()
  ]
}